import { useContext } from 'react';
import { UploadStateContext } from '../context';
export const useShowDownload = (file) => {
    const { showDownload } = useContext(UploadStateContext);
    if (typeof showDownload === 'function')
        return showDownload(file);
    const isUploading = file.status && ['idle', 'uploading'].includes(file.status);
    if (isUploading)
        return false;
    return showDownload;
};
